import { useEffect, useMemo, useRef, useState } from "react"
import styles from "./Ai.module.scss"
import clsx from "clsx"
import PrintPreview from "./PrintPreview"
import ChatMessagesArea from "./ChatMessagesArea"
import moment from "moment"


export const WeatherData = {
  weather: {
    "N": "North",
    "NNE": "North North East",
    "NE": "North East",
    "ENE": "East North East",
    "E": "East",
    "ESE": "East South East",
    "SE": "South East",
    "SSE": "South South East",
    "S": "South",
    "SSW": "South South West",
    "SW": "South West",
    "WSW": "West South West",
    "W": "West",
    "WNW": "West North West",
    "NW": "North West",
    "NNW": "North North West"
  }
};





const HelpAIModal = ({ reportDetails, newDimension = true, closeModal, theme }) => {
  const [openState, setOpenState] = useState(false)

  const [selectedResponseForPrint, setSelectedResponseForPrint] = useState([])

  const [showPreviewModal, setShowPreviewModal] = useState(false)


  const togglePrintPreview = () => {
    setShowPreviewModal((showPreviewModal) => !showPreviewModal)
  }


  const printableMessagesHandler = (selectedMessages) => {
    setSelectedResponseForPrint(selectedMessages)
  }



  return <div
    onClick={() => setOpenState(!openState)}
    style={newDimension ? {
      width: "95%",
      height: "93vh",
      right: "1%",
      bottom: "10px",
    } : {}}
    className={
      clsx(
        styles.aimodalcontainer,
      )}
  >
    <h1 className={clsx({ [styles.darkbackground]: theme === "dark" })}>
      <div>AI assisted Inspection</div>
      <span className={"icon icon-close"} onClick={() => closeModal()}></span>
    </h1>
    {/* <div style={loadingSessionData ? { height: '100%', width: '100%', background: 'white', opacity: 0.7, pointerEvents: 'none', position: "relative" } : { height: '100%', width: '100%', position: "relative" }}>
      <Spinner className={styles.spinner} loading={loadingSessionData} /> */}
    <div>
      {/* <Spinner className={styles.spinner} loading={loadingSessionData} /> */}

      <div className={
        clsx(
          styles.aibody,
        )}>
        <div className={
          clsx(
            styles.selectableTabContainer,
          )}> <div> <span>{`You are currently inspecting ${reportDetails?.equipment_type === "AHU" ? "an" : "a"}`}</span> <span><strong>{`${reportDetails?.equipment_type || ""}`}</strong></span> named <span><strong>{`${reportDetails?.equipmentName || ""}`}</strong></span> from <span><strong>{`${reportDetails?.buildingName || ""}`}</strong></span> on <span><strong>{`${moment(reportDetails?.report_date)?.format("YYYY-MM-DD") || ""}`}</strong></span></div>
          <button onClick={togglePrintPreview} disabled={selectedResponseForPrint?.length === 0}>Export to PDF</button> </div>
        <ChatMessagesArea
          printableMessagesHandler={printableMessagesHandler}
          // @ts-ignore
          diTab={false}
          reportDetails={reportDetails}
          theme={theme} />
      </div>
    </div>
    {showPreviewModal && <PrintPreview reportDetails={reportDetails}
      printableResponse={selectedResponseForPrint} togglePrintPreview={togglePrintPreview}></PrintPreview>}
  </div>
}

export default HelpAIModal
